import classNames from "classnames";
import React, { memo, useEffect, useState } from "react";
import moment, { Moment } from "moment";
import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";

import styles from "./chat-item.module.scss";
import { ChatItemProps } from "./chat-item.types";

const ChatItemComponent: React.FC<ChatItemProps> = memo((props: ChatItemProps) => {
  const [clientTime, setClientTime]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("");

  const today: Moment = moment().endOf("day");
  const dateLastMessage: Moment = moment(props.chat.updated_at);

  const dateFormatLastMessage: string =
    moment(dateLastMessage).diff(today, "days") === 0
      ? moment(dateLastMessage).format("HH:mm")
      : moment(today).diff(dateLastMessage, "week") === 0
        ? moment(dateLastMessage).format("dddd")
        : moment(dateLastMessage).format("DD.MM.YY");

  const chatName: string = props.chat.name;

  const notificationsCount: number = props.chat.notifications ?? 0;

  const { timezone }: ChatWithShortInfo = props.chat;

  useEffect(() => {
    if (!timezone) {
      setClientTime("");
      return;
    }
    setClientTime(moment().tz(timezone).format("HH:mm"));
    const interval: NodeJS.Timeout = setInterval(() => {
      setClientTime(moment().tz(timezone).format("HH:mm"));
    }, 30000);

    return (): void => clearInterval(interval);
  }, [timezone]);

  return (
    <>
      <div
        className={classNames(styles.chatItem, props.selectChatId == props.chat.id ? styles.selected : "")}
        onClick={(): void => {
          props.handleChangeChat(props.chat.id);
        }}
      >
        <div className={styles.information}>
          <div className={styles.informationContact}>
            <div className={styles.name}>
              {chatName}
              <span
                className={classNames(styles.repliedNotification, props.chat.isReplied ? styles.isReplied : "")}
              ></span>
            </div>
            <div className={styles.phoneAndTime}>
              <div className={styles.phone}>{props.opponentPhone ?? ""}</div>
              {clientTime && <div className={styles.time}>Time: {clientTime}</div>}
            </div>
          </div>
          <div className={styles.date}>{dateFormatLastMessage}</div>
        </div>
        <div className={styles.messageInformation}>
          <div className={styles.message}>
            {props.chat.messageLast?.media ? "Media... " : ""}
            {props.chat.messageLast?.message}
          </div>
          <div className={classNames(styles.notifications, notificationsCount > 0 ? styles.notificationsShow : "")}>
            {notificationsCount > 0 ? props.chat.notifications : ""}
          </div>
        </div>
      </div>
    </>
  );
});

ChatItemComponent.displayName = "ChatItemComponent";
export default ChatItemComponent;
